// extracted by mini-css-extract-plugin
module.exports = {"team-banner":"team-env-banner_team-banner__FaVwA","close-button":"team-env-banner_close-button__m9IF1"};